import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue"
import { usePlantStore } from "@/store/plant"


export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props, { expose }) {
  expose();

const plantStore = usePlantStore()
const activeTab = ref(0)

onMounted(() => {
  void plantStore.getAll()
})

const __returned__ = { plantStore, activeTab }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})